<template>
  <div ref="pageView" class="page-view pd-lr-20 container-view">
    <!-- title -->
    <section class="title-section fixed-view">
      <e6-title
        >常用报警设置列表
        <template slot="operate">
          <el-button
            class="g-form-section-search operate__item"
            :class="{ 'is-open': isSearch }"
            title="添加"
            icon="e6-icon-add_line"
            @click="gotoAdd"
            plain
          ></el-button>
          <el-button
            class="g-form-section-search operate__item"
            :class="{ 'is-open': isSearch }"
            title="查询"
            icon="e6-icon-search_line"
            @click="handleIsSearch"
            plain
          ></el-button>
        </template>
      </e6-title>
    </section>
    <!-- title end -->
    <!-- 查询条件 -->
    <section class="g-form-section form-section fixed-view" v-show="isSearch">
      <e6-form-extend
        class="form-extend e6-form--validate"
        :class="{ 'is-open': isSearch }"
        :formExtend="formExtend"
        @submitForm="handlesSubmitForm"
        @resetForm="handleResetForm"
      >
        <template slot-scope="slotForms">
          <el-form-item prop="forms.isOverAll">
            <dict-select
              v-model="slotForms.forms.isOverAll"
              :pkey="'IS_OVER_ALL'"
              placeholder="适用范围"
              clearable
            ></dict-select>
          </el-form-item>
          <!-- <el-form-item prop="forms.alarmTypeId">
            <dict-select
              v-model="slotForms.forms.alarmTypeId"
              :pkey="'commonalarm_type'"
              placeholder="报警分类"
              clearable
            ></dict-select>
          </el-form-item> -->
          <el-form-item prop="forms.telephone">
            <e6Select
              :dataList="vehicleTreeList"
              :filterable="true"
              slotTemplate="tree"
              :issingleleaf="true"
              multiple
              ref="e6select"
              :placeholder="'请选择车辆'"
            >
            </e6Select>
          </el-form-item>
        </template>
        <template slot="submit">查询</template>
        <template slot="reset">重置</template>
      </e6-form-extend>
    </section>
    <!-- 查询条件 end -->
    <!-- 表格tab -->
    <section class="g-table-tab-section table-tab-section fixed-view">
      <e6-flank-fix>
        <template slot="fixRight">
          <i
            class="flank-fix__item e6-icon-clear_line"
            @click="handleBatchDeleteCommonAlarm"
          ></i>
        </template>
      </e6-flank-fix>
    </section>
    <!-- 表格tab end -->
    <!-- 表格 -->
    <section class="table-section" :style="{ height: resizeViewHeight + 'px' }">
      <el-table
        ref="multipleTable"
        border
        :data="tableData"
        height="100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          align="center"
          type="selection"
          width="55"
          :selectable="checkBoxCanSelect"
        ></el-table-column>
        <el-table-column label="序号" width="50" fixed type="index" />
        <el-table-column
          label="适用范围"
          min-width="100"
          fixed
          prop="alarmRangeText"
        />
        <el-table-column
          label="车牌号"
          min-width="200"
          show-overflow-tooltip
          prop="vehicleNo"
        />
        <el-table-column
          label="报警分类"
          min-width="150"
          show-overflow-tooltip
          prop="alarmTypeText"
        />
        <el-table-column label="是否启用" min-width="100" prop="isApplyText" />
        <!-- <el-table-column
          label="平台显示"
          width="100"
          prop="isPlateformShowText"
        />
        <el-table-column label="警音提醒" width="100" prop="isAlarmSoundText" /> -->
        <!--<el-table-column label="通知联系人" width="100" prop="isNotifyLinkmanText"/>-->
        <!-- <el-table-column
          label="通知终端"
          width="100"
          prop="isTerminalShowText"
        />
        <el-table-column label="拍照" width="100" prop="isPhotoText" /> -->
        <!--<el-table-column label="报警详情" width="230" show-overflow-tooltip prop="content"/>-->
        <el-table-column label="修改人" min-width="150" prop="modifyName" />
        <el-table-column
          label="修改时间"
          min-width="170"
          prop="modifiedTimeShow"
        />
        <el-table-column align="center" label="操作" width="100" fixed="right">
          <template slot-scope="scope">
            <router-link
              :to="{
                path: '/alarmSetCommonAlarmSetEdit',
                query: {
                  editType: scope.row.alarmTypeId,
                  alarmSetId: scope.row.alarmSetId
                }
              }"
            >
              编辑
            </router-link>
          </template>
        </el-table-column>
      </el-table>
    </section>
    <!-- 表格 end -->
    <!-- 翻页 -->
    <section class="pagination-section fixed-view">
      <e6-pagination
        :total="total"
        :pageSize.sync="pageSize"
        :currentPage.sync="curPage"
        @currentChange="handleCurrentChange"
        @sizeChange="handleSizeChange"
      ></e6-pagination>
    </section>
    <!-- 翻页 end -->
    <!-- 批量删除确认 -->
    <e6-message-box
      :messageBoxVisible.sync="messageBoxVisible"
      @messageBoxSubmit="handleMessageBoxSubmit"
    >
      <div class="batch-delete">确认删除报警设置？</div>
    </e6-message-box>
    <!-- 批量删除确认 end -->
  </div>
</template>

<script>
import {
  FetchDeleteCommonAlarmSetBatch,
  FetchFindByPage
} from "@/api/alarmSet/commonAlarmSet";
import { mapGetters } from "vuex";
import resizeListener from "_private/mixins/resizeListener";
import { mergeFormExtend } from "_private/utils/merge";
import e6Select from "e6select";
import { FetchVehicleTree } from "@/api/base/vehicle";
export default {
  mixins: [resizeListener],
  components: { e6Select },
  data() {
    return {
      vehicleIdList: [],
      firstLoad: true,
      vehicleTreeList: [],
      total: 0,
      curPage: 1,
      pageSize: 20,
      isSearch: true,
      formExtend: {
        forms: {
          isOverAll: "",
          alarmTypeId: ""
        },
        extends: []
      },
      tableData: [],
      multipleSelection: [],
      messageBoxVisible: false
    };
  },
  computed: {
    ...mapGetters(["moduleId", "userId"]),
    commonAlarmSetIds() {
      let ids = this.multipleSelection.map(item => {
        return item.alarmSetId;
      });
      return ids.length < 1 ? "" : ids.join(",");
    }
  },
  created() {
    //初始化车辆树
    this.initVehicleTree();
    //查询数据
    this.FetchFindByPage(this.mergeObj());
  },
  methods: {
    //初始化车辆树
    initVehicleTree() {
      FetchVehicleTree()
        .then(response => {
          if (response.result && Array.isArray(response.result)) {
            this.vehicleTreeList = response.result;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 获取表格数据
    FetchFindByPage(data) {
      FetchFindByPage(data)
        .then(response => {
          if (
            response.result &&
            response.result.data &&
            Array.isArray(response.result.data)
          ) {
            this.tableData = response.result.data;
            this.total = response.result.totalRecords;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 删除司机信息
    FetchDeleteCommonAlarmSetBatch(data) {
      FetchDeleteCommonAlarmSetBatch(data)
        .then(response => {
          let type = response.code === 1 ? "success" : "error";
          let message = response.message;
          this.$message({
            showClose: true,
            message: message,
            type: type,
            duration: 2000,
            onClose: () => {
              if (type === "success") {
                this.FetchFindByPage(this.mergeObj());
              }
            }
          });
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 整合查询数据
    mergeObj() {
      //首次加载时不获取车辆List
      if (this.firstLoad) {
        this.firstLoad = false;
      } else {
        this.vehicleIdList = this.getVehicleIdListParam();
      }
      return Object.assign({}, mergeFormExtend(this.formExtend), {
        moduleId: this.moduleId,
        vehicleIdList: this.vehicleIdList,
        pageParamVO: {
          curPage: this.curPage,
          pageSize: this.pageSize
        }
      });
    },
    // 是否查询
    handleIsSearch() {
      this.isSearch = !this.isSearch;
      this.$nextTick(() => {
        this.resizeListener();
      });
    },
    // 查询数据
    handlesSubmitForm() {
      this.curPage = 1;
      this.FetchFindByPage(this.mergeObj());
    },
    handleResetForm() {
      this.$refs.e6select.multipleRemoveAll();
    },
    // 表格选择改变事件
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 翻页
    handleCurrentChange(e) {
      this.curPage = e;
      this.FetchFindByPage(this.mergeObj());
    },
    // 设置每页多少条
    handleSizeChange(e) {
      this.pageSize = e;
      this.FetchFindByPage(this.mergeObj());
    },
    // 打开确认删除面板
    handleBatchDeleteCommonAlarm() {
      if (this.commonAlarmSetIds === "") {
        return this.$message({
          showClose: true,
          message: "至少选择一条数据",
          type: "warning",
          duration: 1200
        });
      }
      this.messageBoxVisible = true;
    },
    // 确认删除报警设置
    handleMessageBoxSubmit() {
      this.FetchDeleteCommonAlarmSetBatch({ ids: this.commonAlarmSetIds });
    },
    //设置行是否可选
    checkBoxCanSelect(row, index) {
      //全局设置不可选中删除
      if (row.isOverAll == 1) {
        return false;
      } else {
        return true;
      }
    },
    //获取选中车辆id
    getVehicleIdListParam() {
      let selected = this.$refs.e6select.getSelectValues();
      selected = selected.map(item => {
        return item.id;
      });
      return selected;
    },
    gotoAdd() {
      this.$router.push({
        path: "/alarmSetCommonAlarmSetEdit",
        query: { isCreate: true }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.page-view {
  height: 100%;
}

.title-section {
  padding: 15px 0 10px;
}

.table-section {
  height: 200px;
}

.pagination-section {
  padding: 10px 0;
}

.batch-delete {
  line-height: 100px;
  text-align: center;
  background-color: #fff;
}

.my-tree {
  width: 210px;
  height: 26px;
  line-height: 26px;
  margin-right: 10px;
}

/deep/ .my-tree {
  > div {
    height: 26px;
    line-height: 26px;
  }
}

/deep/
  .my-tree
  .vue-treeselect__control
  .vue-treeselect__value-container
  .vue-treeselect__placeholder {
  padding-top: 0px !important;
  margin-top: -3px !important;
}
</style>
